import React, { useRef } from "react";
import DatePicker from "../../../datePicker/DatePicker";
import DropdownSelect from "../../../dropdown/Dropdown";
import Validation from "../../../../utils/validation/ValidationText";
import moment from "moment";
import TextInput from "../../../UIComponent/TextInput";
import ButtonLoader from "../../../common/buttonLoader/ButtonLoader";

function CorporateMembershipSubscription(props) {

  const initialMembershipTypeId = useRef(null);

  if (
    initialMembershipTypeId.current === null &&
    props.membershipSubscription.membershipTypeId > 0
  ) {
    initialMembershipTypeId.current =
      props.membershipSubscription.membershipTypeId;
  }

  const renewDisabled = (
    [1, 4, 7].includes(props.membershipSubscription.billingCategoryId) && (!props.membershipSubscription.subcriptionEndDate)
    || props.membershipSubscription.membershipTypeId === 4 || props.membershipSubscription.membershipTypeId === 5
  );
  const newApplicationDisabled =
    props.membershipSubscription.membershipTypeId === 4 ||
    props.membershipSubscription.membershipTypeId === 5 ||
    (props.membershipSubscription.isExistsInMembershipTasks === true &&
      props.membershipSubscription.isAppliedForRenewal !== true);
  const renewalDisabled =
    renewDisabled ||
    (props.membershipSubscription.isExistsInMembershipTasks === true &&
      props.membershipSubscription.isAppliedForRenewal === true);

  return (
    <div>
      <div className="2xl:px-10 2xl:py-10 2xl:pt-7 lg:px-7 px-3 lg:py-7 lg:pt-5 pt-4 pb-4">
        <div className="grid grid-cols-12 gap-6 w-full ">
          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12">
                <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                  Membership Type
                  <span className="text-[#c00000]">*</span>
                </h2>

                <DropdownSelect
                  drpIdentity={"MembershipTypesSubscription"}
                  optionArray={props.membershipTypes}
                  setFilterParameters={props.setFilterParameters}
                  value={props.membershipSubscription.membershipTypeId}
                  onBlur={(e) => props.validate("membershipTypeId", props.membershipSubscription)}
                  disabled={initialMembershipTypeId.current === 4 || initialMembershipTypeId.current === 5}
                />
                <Validation error={props.validState.error.membershipTypeId} />
              </div>
            </div>
          </div>
          {props.membershipSubscription.membershipTypeId > 0 && props.membershipSubscription.membershipTypeId === 5 ?
            <>
              <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
                <div className="grid grid-cols-12 gap-6">
                  <div className="col-span-12">
                    <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                      Please select the TAC that you are from
                      <span className="text-[#c00000]">*</span>
                    </h2>

                    <DropdownSelect
                      drpIdentity={"TACFromTypeSubscription"}
                      optionArray={props.tacNames}
                      setFilterParameters={props.setFilterParameters}
                      value={props.membershipSubscription.tacFromId}
                    />
                    <Validation error={props.validState.error.tacFromId} />
                  </div>
                </div>
              </div>
              {props.membershipSubscription.tacFromId > 0 && props.membershipSubscription.tacFromId === 1 ?
                <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
                  <div className="grid grid-cols-12 gap-6">
                    <div className="col-span-12">
                      <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                        TAC Name
                        <span className="text-[#c00000]">*</span>
                      </h2>

                      <TextInput
                        type="text"
                        name="tacName"
                        value={props.membershipSubscription.tacName}
                        identity="MemebershipSubscription"
                        handleChange={(e) => props.handleChange(e, 'MemebershipSubscription')}
                      />
                      <Validation error={props.validState.error.tacName} />
                    </div>
                  </div>
                </div>
                : null}
            </>
            : null}
          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12">
                <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                  Billing Category
                  <span className="text-[#c00000]">*</span>
                </h2>

                <DropdownSelect
                  drpIdentity={"corporateMemberBillingCategoryId"}
                  optionArray={props.billingCategory}
                  setFilterParameters={props.setFilterParameters}
                  value={props.membershipSubscription.billingCategoryId}
                  onBlur={(e) => props.validate("corporateMemberBillingCategoryId", props.membershipSubscription)}
                  disabled={true}
                />
                <Validation error={props.validState.error.corporateMemberBillingCategoryId} />
              </div>
            </div>
          </div>
          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12">
                <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                  Subscription Start Date
                </h2>
                <div className="disabled-input dropdwn-input-email flex items-center">
                  <DatePicker
                    isDisable={true}
                    name="subscriptionStartDate"
                    handleChange={props.handleChange}
                    identity="MembershipSubscription"
                    value={moment(props.membershipSubscription.subscriptionStartDate).format("yyyy-MM-DD")}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12">
                <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                  Subscription End Date
                </h2>
                <div className="disabled-input dropdwn-input-email flex items-center">
                  <DatePicker
                    isDisable={true}
                    name="subcriptionEndDate"
                    handleChange={props.handleChange}
                    identity="MembershipSubscription"
                    value={moment(props.membershipSubscription.subcriptionEndDate).format("yyyy-MM-DD")}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12">
                <h2 className="text-xl theme-color font-bold 2xl:mb-1">
                  Updated By
                </h2>
                <DropdownSelect
                  disabled={true}
                  drpIdentity={"updatedById"}
                  optionArray={props._by}
                  setFilterParameters={props.setFilterParameters}
                  value={props.membershipSubscription.updatedBy}
                />
              </div>
            </div>
          </div>
          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12">
                <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                  Last Updated Date
                </h2>
                <div className="disabled-input">
                  {props.membershipSubscription.updatedAt === "" || props.membershipSubscription.updatedAt === null ?

                    <TextInput
                      disabled={true}
                      placeholder=""
                      type="text"
                      name="linkedIn"
                      value="None"
                      identity="BasicInformation"
                    />
                    :
                    <DatePicker
                      isDisable={true}
                      name="updatedAt"
                      handleChange={props.handleChange}
                      identity="updatedAt"
                      value={moment(props.membershipSubscription.updatedAt).format("yyyy-MM-DD")}
                    />
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Renew Button */}
        <div className="grid grid-cols-12 gap-4 lg:mt-10 mt-5">
          <div className="xl:col-span-12 lg:col-span-12 col-span-12 flex flex-wrap gap-4 justify-end">

            {/* New Application */}
            <div className="flex items-center">
              {props && props.isLoadingForNewRenewal ? (
                <ButtonLoader />
              ) : (
                <button
                  className={`w-36 py-4 text-xl font-semibold text-white transition duration-200 
                  ${newApplicationDisabled
                      ? 'bg-gray-400 cursor-not-allowed'
                      : 'btn-red hover:bg-yellow-600'}`}
                  onClick={() => props.renewNewCorporateMember()}
                  disabled={newApplicationDisabled}
                >
                  New Application
                </button>
              )}
            </div>

            {/* Renew */}
            <div className="flex items-center">
              {props && props.isLoadingForRenewal ? (
                <ButtonLoader />
              ) : (
                <button
                  className={`w-32 py-4 text-xl font-semibold text-white transition duration-200 
                  ${renewalDisabled
                      ? 'bg-gray-400 cursor-not-allowed'
                      : 'btn-red hover:bg-yellow-600'}`}
                  onClick={() => props.renewCorporateMember()}
                  disabled={renewalDisabled}
                >
                  Renew
                </button>
              )}
            </div>

            {/* Save */}
            <div className="flex items-center">
              {props && props.isLoading ? (
                <ButtonLoader />
              ) : (
                <button
                  className="w-32 py-4 text-xl font-semibold text-white btn-red hover:bg-gray-800 transition duration-200"
                  onClick={() => props.onSave()}
                >
                  Save
                </button>
              )}
            </div>

          </div>
        </div>
        {
          props.membershipSubscription.isExistsInMembershipTasks === true ?
            (
              <div className="flex justify-end mt-5 items-center">
                <p className="text-red-500 text-sm font-bold 2xl:mb-1">
                  This member already exists in the Task List as a {props.membershipSubscription.isAppliedForRenewal === true ? "Renewal" : "New Application"}.
                  {!(newApplicationDisabled && renewalDisabled) &&
                    ` Click "${props.membershipSubscription.isAppliedForRenewal === true ? "New Application" : "Renew"}" to update it.`}
                </p>
              </div>
            )
            :
            null
        }
      </div>
    </div>
  );
}

export default CorporateMembershipSubscription;
